import { Component } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType } from '@ngx-formly/core';
import { WidgetAssetPreviewComponent } from '../../../asset/widget-asset-preview/widget-asset-preview.component';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../../@core/services/notification/notification.service';
import { SettingsService } from '../../../../@core/services/settings.service';
import { Asset, AssetInput, Product, ProductInput } from '../../../../generated/generated-types';
import { AssetService } from '../../../asset/services/asset.service';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-product-featured-asset',
  templateUrl: './product-featured-asset.component.html',
  standalone: true,
  imports: [
    WidgetAssetPreviewComponent,
  ]
})
export class ProductFeaturedAssetComponent extends FieldType {

  constructor(
    private assetService: AssetService,
    private productService: ProductService,
    private settingService: SettingsService,
    private notificationService: NotificationService,
    private i18n: I18nService
  ) {
    super();
  }

  async onFilesSelected(files: File[]): Promise<void> {

    if (!this.model?.id) {
      this.notificationService.error(_("error.save-first"));
      return
    }

    if (files?.length) {

      let product = this.model as Product;
      let assets: Asset[] = [];

      for (let file of files) {

        const compressedImage = await this.assetService.resizeImageIfNeeded(file);

        // if its no image file
        if (compressedImage) {
          file = compressedImage;
        }

        const input: AssetInput = {
          file: file,
          name: file.name
        }

        const res = await this.assetService.saveAsset(input);
        assets.push(res);

      }

      for (let asset of assets) {
        let updateProd: ProductInput = {
          id: product.id,
          featuredAssetId: asset.id
        }

        await this.productService.saveItem(updateProd);
      }
      this.notificationService.success(_("common.save-successful"));
    }
  }

  getAsset(key: string | number | (string | number)[]): Asset {
    if (this.model)
      return this.model[key as string];
  }

}
